import React, { useEffect, useState } from 'react';
import '../assets/css/material-dashboard.css'
import './criarordemmodal.css'
import HomeLf from './HomeLf';
import { db, firebaseAuth } from '../utils/firebase-config';
import { onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { collection, doc, getDocs, updateDoc } from 'firebase/firestore';
import Background from 'three/examples/jsm/renderers/common/Background.js';
import { Center } from '@react-three/drei';

import logo from '../assets/version2/logo.png'

function Descricao(params) {

  const navigate = useNavigate();


  const [current, setCurrent] = useState('');
  const [dataA, setDataA] = useState([]);
  const [filtrados, setFiltrados] = useState([]);
  const [filtradosB, setFiltradosB] = useState([]);
  const [objetoTarget, setObjetoTarget] = useState();
  const [dataId, setDataId] = useState();
  const [nomeproj, setNomeproj] = useState('');

  const [dataMaster, setDataMaster] = useState([]);


    const [mapeA, setMapeA] = useState([1]);
    const [hide, setHide] = useState('flex');

var count01 = 0;
const queryParameters = new URLSearchParams(window.location.search)
const parametroId = queryParameters.get("prjid")


const [countMp, setCountMp] = useState(1);

const [dataPendencias, setDataPendencias] = useState([]);






async function master(params) {

      

  var objMaster = [];
  var objMaster2 = [];

   


  onAuthStateChanged(firebaseAuth, async (currentUser) => {
    if (currentUser) {
      var usuarioLogado = currentUser.email;
      setCurrent(usuarioLogado);
    };
  });


  await fetch('https://apilumera.shop/api/consultaOrdem', {
    method: 'POST',
    body: JSON.stringify({
      parametroId: parametroId,

    }),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  })
     .then((response) => response.json())
     .then((data) => {

        var criados = data;
        var tradd = [];

        
        setFiltradosB(criados);


        tradd.push(criados.ordens);

        tradd = tradd[0];
        console.log('SSSSSS ',tradd);
        var masterTrad = [];
      for (let i = 0; i < Object.keys(criados.ordens).length; i++) {
            console.log(tradd[Object.keys(criados.ordens)[i]]);
            masterTrad.push(tradd[Object.keys(criados.ordens)[i]]);
      }
            var filtrar = [];
        for (let i = 0; i < masterTrad.length; i++) {
          if(masterTrad[i].status == 'Pendente'){
            filtrar.push(masterTrad[i]);
          }
          
        }
        console.log('MASTER MASTER', masterTrad);
      setFiltrados(filtrar);
              











     })
     .catch((err) => {
        console.log(err.message);
     });























     await fetch('https://apilumera.shop/api/consultaprojeto', {
      method: 'POST',
      body: JSON.stringify({
        id: parametroId,
  
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    })
       .then((response) => response.json())
       .then((data) => {

          var projetoAtual = data;               
          setNomeproj(projetoAtual.nomeDoProjeto);
        setDataMaster(projetoAtual.colaboradores);
  
       })
       .catch((err) => {
          console.log(err.message);
       });
  









































        



}


async function editar(params) {
  navigate(`/editar?projeto=${params}`);
}





async function dell(params) {


  await updateDoc(doc(db, 'clientes', `${firebaseAuth.currentUser.email}:projetos`), {
    [params]: {
        nomeDoProjeto: 'nd',
      

    }
  
  });
  navigate(0);
}






useEffect(()=> {
  master();
},[])











function enviarPost01() {


  function getObj(params) {

    for (let i = 0; i < dataMaster.length; i++) {
        if(dataMaster[i].split('###master')[3].replaceAll(' ', '') == params.replaceAll(' ', '')){
          return dataMaster[i];
        }
    }
}



var tradecolaboradores = [];
for (let i = 0; i < document.querySelectorAll('.colaboradores').length; i++) {
    tradecolaboradores.push(getObj(document.querySelectorAll('.colaboradores')[i].value.replaceAll(' ', '')))
  
}
  
  console.log('tradecolaboradores ',tradecolaboradores);

  var emailsColaboradores = [];

  for (let i = 0; i < tradecolaboradores.length; i++) {
    emailsColaboradores.push(tradecolaboradores[i].split('###master')[0]);
    
  }

  var nomeDaPendencia = document.querySelector('.inputNormal').value;
  var prioridadependencia = document.querySelector('.prioridade').value;



  fetch('https://apilumera.shop/api/criarordem', {
    method: 'POST',
    body: JSON.stringify({
      email: firebaseAuth.currentUser.email,
      parametroId: parametroId,
      nomeOrdem: nomeDaPendencia,
      participantes: tradecolaboradores,
      emailsParticipantes: emailsColaboradores,
      prioridade: prioridadependencia,
      nomeProjeto: nomeproj
    //  ordemPrioridade: ordemPrioridade
    }),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  })
     .then((response) => response.json())
     .then((data) => {
        navigate(-1);
     })
     .catch((err) => {
      navigate(-1);
     });



}



























var trad = [];

function mapear() {
            
  setCountMp(countMp + 1);

  for (let i = 0; i < countMp; i++) {
      trad.push(i);
      
  }
  trad.push(countMp);
  setMapeA(trad);
}







    return (
        <div>


<HomeLf/>

















<div style={{backgroundColor: 'rgba(100,100,100,0.5)', width: '100%', height: '100%', position: 'absolute',
 display: hide ,justifyContent: 'center', alignItems: 'center'

}}>


<div style={{ width: '500px',borderRadius: '16px', backgroundColor: '#fff', paddingBottom: '30px'}}>
<div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '10px',
paddingLeft: '20px', paddingRight: '20px',
alignItems: 'center'

}}>
<div><img src={logo} style={{width: '120px'}}></img></div>
<div>    <i class="bi bi-x" style={{fontSize: '25px', cursor: 'pointer'}}
onClick={()=> setHide('none')}
/>
</div>

</div>
<div>

<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-12" style={{borderRadius: '10px 10px 10px 10px', display: 'flex', fontSize: '16px', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(100, 100, 100, 0.02)', color: 'rgb(90, 90, 90)', fontWeight: 'bold'}}>Nova Pendência</div>
</div>

<div style={{padding: '0px 30px', marginTop: '30px'}}>
<div style={{fontWeight: 'bold', marginBottom: '2px'}}>Nome da pendência</div>
<div className="dastasColaboradores" style={{display: 'flex', marginBottom: '12px', flexFlow: 'row wrap', gap: '10px', marginTop: '10px'}}>
<input className='inputNormal' style={{padding: '5px 5px', borderRadius: '5px', border: 'solid 1px rgb(100, 100, 100)'}} placeholder='Nome da pendência'></input>
</div>
<div style={{fontWeight: 'bold', marginBottom: '12px'}}>Colaboradores</div>
<div className="dastasColaboradores" style={{display: 'flex', flexFlow: 'row wrap', gap: '10px', marginTop: '10px'}}>

{mapeA.map((data, index)=> {
return <>



<select className="colaboradores" style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', height: '35px', borderRadius: '10px', padding: '0px 14px'}}
>
  {dataMaster.map((data, index)=> {
    return <>
    
      <option value={data.split('###master')[3]}>{data.split('###master')[3]}</option>
    
    </>


  })}

</select>





</>
})}
<div>
  <i class="bi bi-plus"
   style={{fontSize: '30px', cursor: 'pointer',
    lineHeight: '15px', color: 'rgb(6, 129, 6)'}}
    onClick={()=> mapear()}
    ></i>
    </div>

</div>


<div style={{fontWeight: 'bold', marginBottom: '12px', marginTop: '15px'}}>Prioridade</div>
<select className="prioridade" style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', height: '35px', borderRadius: '10px', padding: '0px 14px'}}
>

<option value="baixa">Baixa</option>
<option value="media">Média</option>
<option value="alta">Alta</option>

</select>


</div>



<div style={{display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%', padding: '0px 30px', marginTop: '28px'}}>
        <div
         style={{width: '150px', height: '35px', borderRadius: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: '600', color: '#fff', backgroundColor: '#985EAC'}}
          onClick={()=> enviarPost01()}
        >Criar Pendência</div>
</div>

</div>



<div style={{display: 'none'}}>

<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-6" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: '#985EAC', color: '#fff'}}>Novo Projeto</div>
<div className="col-6" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(100,100,100,0.1)', color: 'black'}}>Colaboradores</div>
</div>



<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-7" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center'}}>
    

<input style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Email do colaborador"></input>
</div>
<div className="col-5" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', color: 'black'}}>
    <select style={{width: '100%', height: '35px', borderRadius: '10px'}}>
    <option value="Administrador"  style={{border: 'none'}}>Administrador</option>
  <option value="Gerente">Gerente</option>
  <option value="Engenheiro">Engenheiro</option>
  <option value="Prestador de serviços">Prestador de serviços</option>
    </select>

</div>
</div>






</div>






</div>

</div>
      











<div
  className="col-12"
  style={{
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "center",
    marginTop: 50,
    paddingRight: 20
  }}
>
  <div className="col-3" style={{ padding: "0px 20px" }}>
    <div
      style={{
        border: "1px solid #DEE1E6",
        height: "100%",
        width: "100%",
        borderRadius: 10
      }}
    >
      <div
        style={{
          padding: "30px 0px",
          display: "flex",
          justifyContent: "center",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px"
        }}
      >
        <div
          style={{
            width: 154,
            height: 36,
            backgroundColor: "#574A69",
            borderRadius: 10,
            fontFamily: "inter, serif",
            fontSize: 14,
            color: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: 'pointer'
          }}
          onClick={()=> navigate(`/criarordem?prjid=${parametroId}`)}
        >
          <a style={{ fontSize: 25, fontWeight: 200, marginRight: 4 }}>+ </a>{" "}
          Nova Pendência
        </div>
      </div>
      <div
        style={{
          padding: "30px 10px",
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px",
          fontFamily: "Archivo, serif",
          fontWeight: 500,
          fontSize: 16,
          color: "#171A1F"
        }}
      >
        Filtros{" "}
        <a style={{ fontSize: 14, fontWeight: 400, color: "#574A69" }}>
          Limpar Tudo
        </a>
      </div>
      <div
        style={{
          padding: "30px 10px",
          display: "flex",
          flexFlow: "column",
          justifyContent: "space-between",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px",
          fontFamily: "Archivo, serif",
          fontWeight: 500,
          fontSize: 16,
          color: "#171A1F"
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <a>Status</a>{" "}
          <a style={{ fontSize: 14, fontWeight: 400, color: "#574A69" }}>
            <i style={{ color: "black" }} className="bi bi-chevron-down" />
          </a>
        </div>
        <div
          style={{
            marginTop: 15,
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
          />{" "}
          <a>Pendente</a>
        </div>
        <div
          style={{
            marginTop: 5,
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
          />{" "}
          <a>Concluído</a>
        </div>
      </div>
      <div
        style={{
          padding: "30px 10px",
          display: "flex",
          flexFlow: "column",
          justifyContent: "space-between",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px",
          fontFamily: "Archivo, serif",
          fontWeight: 500,
          fontSize: 16,
          color: "#171A1F"
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <a>Responsável pela Solução</a>{" "}
          <a style={{ fontSize: 14, fontWeight: 400, color: "#574A69" }}>
            <i style={{ color: "black" }} className="bi bi-chevron-down" />
          </a>
        </div>
        <div
          style={{
            marginTop: 15,
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
          />{" "}
          <a>Mecânica</a>
        </div>
        <div
          style={{
            marginTop: 5,
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
          />{" "}
          <a>Civil</a>
        </div>
        <div
          style={{
            marginTop: 5,
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
          />{" "}
          <a>Elétrica</a>
        </div>
      </div>
      <div
        style={{
          padding: "30px 10px",
          display: "flex",
          flexFlow: "column",
          justifyContent: "space-between",
          borderBottom: "1px solid #F3F4F6",
          margin: "0px 10px",
          fontFamily: "Archivo, serif",
          fontWeight: 500,
          fontSize: 16,
          color: "#171A1F"
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <a>Requisitante</a>{" "}
          <a style={{ fontSize: 14, fontWeight: 400, color: "#574A69" }}>
            <i style={{ color: "black" }} className="bi bi-chevron-down" />
          </a>
        </div>
        <div
          style={{
            marginTop: 15,
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
          />{" "}
          <a>Tubulação</a>
        </div>
        <div
          style={{
            marginTop: 5,
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
          />{" "}
          <a>Civil</a>
        </div>
        <div
          style={{
            marginTop: 5,
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400,
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "center"
          }}
        >
          <input
            style={{ width: 14, height: 14, marginRight: 5 }}
            type="checkbox"
          />{" "}
          <a>Elétrica</a>
        </div>
      </div>
    </div>
  </div>
  <div className="col-9">
    <div>
      <div style={{ marginBottom: 40 }}>
        <h2 className="meusProjetos">Nome do projeto</h2>
      </div>
      <div
        style={{ marginBottom: 50, marginLeft: "-30px" }}
        className="d-flex row wrap flex-row"
      >
        <div
          className="col-3 d-flex justify-content-center"
          style={{
            borderRight: "1px solid #BDC1CA",
            display: "flex",
            flexFlow: "column",
            alignItems: "center",
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400
          }}
        >
          <div style={{ display: "flex", flexFlow: "column" }}>
            Pendencias (Total)
            <a
              style={{
                marginTop: 15,
                fontFamily: "Archivo, serif",
                fontSize: 32,
                fontWeight: 600
              }}
            >
              10
            </a>
          </div>
        </div>
        <div
          className="col-3 d-flex justify-content-center"
          style={{
            borderRight: "1px solid #BDC1CA",
            display: "flex",
            flexFlow: "column",
            alignItems: "center",
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400
          }}
        >
          <div style={{ display: "flex", flexFlow: "column" }}>
            <div style={{ display: "flex" }}>
              Criação:{" "}
              <div
                className="red"
                style={{
                  width: 45,
                  height: 24,
                  backgroundColor: "#FDF2F2",
                  borderRadius: 14,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  paddingRight: 5,
                  marginLeft: 5
                }}
              >
                <i
                  className="bi bi-arrow-up-short"
                  style={{ paddingBottom: 6, fontSize: 18 }}
                />
                <a style={{ paddingBottom: 2 }}>Alta </a>
              </div>{" "}
            </div>
            <a
              style={{
                marginTop: 15,
                fontFamily: "Archivo, serif",
                fontSize: 32,
                fontWeight: 600
              }}
            >
              10
            </a>
          </div>
        </div>
        <div
          className="col-3 d-flex justify-content-center"
          style={{
            borderRight: "1px solid #BDC1CA",
            display: "flex",
            flexFlow: "column",
            alignItems: "center",
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400
          }}
        >
          <div style={{ display: "flex", flexFlow: "column" }}>
            <div style={{ display: "flex" }}>
              ID:{" "}
              <div
                className="red"
                style={{
                  height: 24,
                  backgroundColor: "#FEF6F1",
                  borderRadius: 14,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 71,
                  paddingRight: 5,
                  marginLeft: 5
                }}
              >
                <i
                  className="bi bi-arrow-right-short"
                  style={{ paddingBottom: 6, fontSize: 18 }}
                />
                <a style={{ paddingBottom: 2 }}>Média </a>
              </div>{" "}
            </div>
            <a
              style={{
                marginTop: 15,
                fontFamily: "Archivo, serif",
                fontSize: 32,
                fontWeight: 600
              }}
            >
              10
            </a>
          </div>
        </div>
        <div
          className="col-3 d-flex justify-content-center"
          style={{
            display: "flex",
            flexFlow: "column",
            alignItems: "center",
            fontFamily: "Inter, serif",
            fontSize: 14,
            fontWeight: 400
          }}
        >
          <div style={{ display: "flex", flexFlow: "column" }}>
            <div style={{ display: "flex" }}>
            Última Atualização:{" "}
              <div
                className="red"
                style={{
                  height: 24,
                  backgroundColor: "#FEF9EE",
                  borderRadius: 14,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 70,
                  paddingRight: 5,
                  marginLeft: 5
                }}
              >
                <a style={{ paddingBottom: 2 }}>Pendente </a>
              </div>{" "}
            </div>
            <a
              style={{
                marginTop: 15,
                fontFamily: "Archivo, serif",
                fontSize: 32,
                fontWeight: 600
              }}
            >
              10
            </a>
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexFlow: "row nowrap",
          justifyContent: "space-between"
        }}
      >
        <div
          style={{
            fontFamily: "Archivo, serif",
            fontWeight: "bold",
            fontSize: 24
          }}
        >
          Pendências
        </div>
        <div style={{ display: "flex", gap: 16 }}>
          <div
            style={{
              backgroundColor: "#FAEDFF",
              width: 36,
              height: 36,
              borderRadius: 6,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <img style={{ width: 14, height: 13 }} src="./listicon.png" />
          </div>
          <div
            style={{
              backgroundColor: "#F8F9FA",
              width: 36,
              height: 36,
              borderRadius: 6,
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <img style={{ width: 12, height: 15 }} src="./gridicon.png" />
          </div>
        </div>
      </div>










{filtrados.map((data, index)=> {

return <>


<div style={{ marginTop: 20 }}>
        {" "}
        {/* COL 12 SISTEM */}
        <div
          style={{
            border: "1px #DEE1E6 solid",
            borderRadius: 12,
            padding: 18,
            height: 168
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              height: 40
            }}
          >
            <div
              style={{
                display: "flex",
                flexFlow: "row nowrap",
                justifyContent: "center",
                alignContent: "center",
                fontFamily: "Convergence, serif",
                fontSize: 18
              }}
            >
              {data.nome}
              <div
                className="red"
                style={{
                  height: 24,
                  backgroundColor: "#FEF6F1",
                  borderRadius: 14,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: 71,
                  paddingRight: 5,
                  marginLeft: 15,
                  color: "#AE530D"
                }}
              >
                <i
                  className="bi bi-arrow-right-short"
                  style={{ paddingBottom: 6, fontSize: 18 }}
                />
                <a style={{ paddingBottom: 2 }}>{data.prioridade[0].toUpperCase()+data.prioridade.slice(1,data.prioridade.length)} </a>
              </div>{" "}
            </div>
            <div>
              <div
                style={{
                  display: "flex",
                  fontFamily: "Inter, serif",
                  fontSize: 12
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexFlow: "column",
                    justifyContent: "center"
                  }}
                >
                  {" "}
                  Status:
                </div>{" "}
                <div
                  className="red"
                  style={{
                    height: 24,
                    backgroundColor: "#FEF9EE",
                    borderRadius: 14,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: 70,
                    paddingRight: 5,
                    marginLeft: 5
                  }}
                >
                  <a style={{ paddingBottom: 2, color: "#98690C" }}>
                    {data.status}{" "}
                  </a>
                </div>{" "}
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              alignItems: "center",
              marginTop: 10
            }}
          >
            <div
              style={{
                height: 70,
                display: "flex",
                flexFlow: "column",
                textAlign: "center",
                justifyContent: "center",
                backgroundColor: "#F8F9FA",
                borderRadius: 6,
                padding: "0px 45px"
              }}
            >
              <a
                style={{
                  fontFamily: "Inter, serif",
                  fontSize: 14,
                  fontWeight: "bold"
                }}
              >
                Mecânica
              </a>
              <a style={{ fontFamily: "Inter, serif", fontSize: 12 }}>
                Requisitante
              </a>
            </div>
            <div
              style={{
                height: 70,
                display: "flex",
                flexFlow: "column",
                textAlign: "center",
                justifyContent: "center",
                backgroundColor: "#F8F9FA",
                borderRadius: 6,
                padding: "0px 45px"
              }}
            >
              <a
                style={{
                  fontFamily: "Inter, serif",
                  fontSize: 14,
                  fontWeight: "bold"
                }}
              >
                Civil, Tubulação
              </a>
              <a style={{ fontFamily: "Inter, serif", fontSize: 12 }}>
                Responsável pela Solução
              </a>
            </div>
            <div
              style={{
                height: 70,
                display: "flex",
                flexFlow: "column",
                textAlign: "center",
                justifyContent: "center",
                backgroundColor: "#F8F9FA",
                borderRadius: 6,
                padding: "0px 45px"
              }}
            >
              <a
                style={{
                  fontFamily: "Inter, serif",
                  fontSize: 14,
                  fontWeight: "bold"
                }}
              >
                24/02/2025
              </a>
              <a style={{ fontFamily: "Inter, serif", fontSize: 12 }}>
                Data de Criação
              </a>
            </div>
            <div
              style={{
                width: 154,
                height: 36,
                backgroundColor: "#574A69",
                borderRadius: 10,
                fontFamily: "inter, serif",
                fontSize: 14,
                color: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                cursor: 'pointer'
              }}
              onClick={()=> navigate(`/ordem?prjid=${parametroId}&ordem=${data.nome}`)}
            >
              <a style={{ fontSize: 14, fontWeight: 200, marginRight: 4 }}>
                <i className="bi bi-search" />{" "}
              </a>{" "}
              Ver Pendência
            </div>
            <div
              style={{
                width: 170,
                height: 36,
                backgroundColor: "#574A69",
                borderRadius: 10,
                fontFamily: "inter, serif",
                fontSize: 14,
                color: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <a style={{ fontSize: 14, fontWeight: 200, marginRight: 4 }}>
                <i className="bi bi-check2" />{" "}
              </a>{" "}
              Finalizar Pendência
            </div>
          </div>
        </div>
      </div>




</>

})}




















    </div>
  </div>
</div>







        </div>
    )
}
export default Descricao;